import { useBraze } from '@/components/Braze';
import type { ProfileState } from '@/hooks/useUser';
import { useMount } from '@simplywallst/ui-core';

export const BrazeLogUserRegistered = ({ user }: { user: ProfileState }) => {
  const { logCustomEvent } = useBraze();

  useMount(() => {
    logCustomEvent('user_registered', {
      first_name: user.givenName,
      last_name: user.familyName,
      email: user.emailAddress,
      default_market: user.defaultMarketISOWithUsFallback,
    });
  });

  return null;
};
